import { isPlainObject, isSerializableLeaf } from '../utils/isPlainObject.ts';

const warnedConstructors = new Set<string>();

function warnNonSerializable(name: string, path: string) {
  if (warnedConstructors.has(name)) return;
  warnedConstructors.add(name);
  const location = path ? ` at "${path}"` : '';
  console.warn(
    `[yupMemoizedResolver] Non-serializable object "${name}" in form values${location}. ` +
      'Form values must only contain primitives, plain objects, arrays, Date, File, or Blob. ' +
      'Custom class instances cause DataCloneError with structuredClone.',
  );
}

export function assertNoCustomInstances(obj: unknown, path = '') {
  if (isSerializableLeaf(obj)) return;

  if (Array.isArray(obj)) {
    for (let i = 0; i < obj.length; i++) {
      assertNoCustomInstances(obj[i], `${path}.${i}`);
    }
    return;
  }

  if (!isPlainObject(obj)) {
    warnNonSerializable((obj as object).constructor?.name ?? 'unknown', path);
    return;
  }

  for (const key of Object.keys(obj as object)) {
    assertNoCustomInstances(
      (obj as Record<string, unknown>)[key],
      path ? `${path}.${key}` : key,
    );
  }
}

/**
 * Resetta le classi gia segnalate (utile nei test).
 */
export function resetWarnedConstructors() {
  warnedConstructors.clear();
}
